import {Link, useParams} from "react-router-dom";
import {ResponsiveContent} from "../../ResponsiveNavTabs";
import React, {useRef, useState} from "react";
import {useLocalFilter2, useLongPress, useSelect} from "../../../hooks";
import {useOrder, useOrderCount, useOrderList, useOrderOrderOptions} from "./useOrder";
import {Button, ListGroup, Stack} from "react-bootstrap";
import {
    AdminUserAlert,
    ItemLoading,
    MenuBar,
    MenuOrderBy,
    MenuSearchTerm,
    OurClearAlert, OurPagination2,
    PageTitle
} from "../../_components";
import {isoTimestampToReadableDateOnly} from "../admin/utilities/readableDate";
import {useAlert} from "../../../context";
import {ABOverlayTooltip} from "../../_components/CustomOverlayTooltip";

export function Orders() {
    return <ResponsiveContent body={<OrderBody/>}/>
}

function OrderBody() {
    const {uid} = useParams()

    // Get order options
    const {orderOptions, errorOrderOptions, clearErrorOrderOptions} = useOrderOrderOptions()

    // API count all items
    const {count, loadingCount, errorCount, clearErrorCount} = useOrderCount()

    // API items per page
    const {list, loadingList, errorList, clearErrorList} = useOrderList()

    // Filter
    const filteredList = useLocalFilter2(list, ["shipping_name"])

    // Select
    const [selList, toggleSelectItems, _, isItemSelected] = useSelect(list)

    return <Stack>

        <AdminUserAlert/>
        <OurClearAlert variant="danger" msg={errorOrderOptions} onClear={clearErrorOrderOptions}/>
        <OurClearAlert variant="danger" msg={errorCount} onClear={clearErrorCount}/>
        <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>

        <PageTitle title="Orders">View {list.length} of {count} orders.</PageTitle>

        <MenuBar>
            <MenuSearchTerm/>
            <MenuOrderBy orderOptions={orderOptions}/>
        </MenuBar>

        <ItemLoading show={loadingCount || loadingList}/>

        {list && list.length > 0 ?
            <ListGroup variant="flush">
                {filteredList.map(item =>
                    <RenderItem key={item.id}
                                item={item}
                                selected={isItemSelected(item.id)}
                                selectedCount={selList.length}
                                onSelect={toggleSelectItems}
                                to={`/backend/order/${uid}/${item.id}`}
                    />
                )}
            </ListGroup>
            :
            <span className="text-center">No orders.</span>
        }

        <OurPagination2 loading={loadingCount || loadingList} itemCount={count}/>

    </Stack>
}

function RenderItem({item, selected, selectedCount, onSelect, to}) {
    const [show, setShow] = useState(false)
    const {success, error} = useAlert()

    const {getInvoice} = useOrder()

    // function handleDownload() {
    //     getInvoice(item.id)
    //         .then(msg => success(msg))
    //         .catch(err => console.error(err))
    // }

    function handleDownload() {
        getInvoice(item.id)
            .then(() => success("Invoice downloaded!"))
            .catch((err) => error(err))
    }

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))

    const capitalize = str => str ? str.charAt(0).toUpperCase() + str.slice(1) : ""

    const shipping_tracking_url = item.shipping_tracking_url + "/" + item.shipping_track

    return (
        // <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${selected && "bg-light"} ${show && "bg-light-subtle"}`}
        <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${(selected || show) && "bg-light-subtle"}`}
               onMouseEnter={() => setShow(true)}
               onMouseLeave={() => setShow(false)}>
            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    <i className="bi bi-box fs-2"/>
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">Orders n. {item.order_number}</span>
                        </Link>
                        <span className="text-wrap fs-6 fw-light">Articles: {item.count_articles}, Total: {item.total_price} €</span>
                        <span className="text-wrap fs-6 fw-light">{isoTimestampToReadableDateOnly(item.created_at)}</span>
                    </Stack>
                </div>
                <div className="ms-auto">
                    <Stack className="text-body-tertiary align-items-end justify-content-center" gap={0}>
                        <span
                            className="text-wrap fw-normal text-secondary">{capitalize(item.status)} {item.shipped_at && ` (${isoTimestampToReadableDateOnly(item.shipped_at)})`}</span>
                        {item.shipping_track && <span className="text-nowrap fw-normal text-secondary">{item.shipping_company} <a href={shipping_tracking_url}
                                                                                                                                  target="_blank">track my order</a></span>}
                    </Stack>
                </div>
            </Stack>

            <div className="ms-auto">
                <ABOverlayTooltip tip="Generate proforma/invoice"><Button className="link-underline link-underline-opacity-0" variant="link" onClick={handleDownload}>
                    <span className="bi-box-arrow-down"/>
                </Button></ABOverlayTooltip>

                {/*<Button className="link-underline link-underline-opacity-0" variant="link" onClick={handleDownload} disabled={item.status !== "delivered"}>*/}
                {/*    <span className="bi-box-arrow-down"/>*/}
                {/*</Button>*/}
            </div>
        </Stack>
    )
}

